import { cx } from '@emotion/css';
import { css } from '@emotion/react';
import head from 'lodash/head';
import last from 'lodash/last';

import { getNameByFinancialCompanyCode } from '@common/constants';
import { Gray_Light_100, Typography } from '@common/styles';
import { displayPrice } from '@common/utils';
import { FinancialCompanyCode } from '@domains/pdp-common';

import { PaymentProps } from './InterestFree';

interface InterestFreeViewProps {
  financialCompanyList: PaymentProps[];
}

export function InterestFreeView({ financialCompanyList }: InterestFreeViewProps) {
  return (
    <div css={interest_fee} className={Typography.BODY_13_SEMIBOLD}>
      <div className={cx('head', 'interest_fee__row')}>
        <div className='interest_fee__col'>카드사</div>
        <div className='interest_fee__col'>할부적용금액</div>
        <div className='interest_fee__col'>할부개월</div>
      </div>
      {financialCompanyList.map(({ financial_company_code, installment_month_list, min_amount }, i) => {
        if (financial_company_code === FinancialCompanyCode.UNKNOWN) {
          return null;
        }
        const installmentMonth =
          installment_month_list.length > 1
            ? `${head(installment_month_list)}~${last(installment_month_list)}`
            : `${head(installment_month_list)}`;

        return (
          <div className='interest_fee__row' key={`${i}-${financial_company_code}`}>
            <div className='interest_fee__col'>{getNameByFinancialCompanyCode('ko', financial_company_code)}</div>
            <div className='interest_fee__col'>
              {displayPrice(min_amount)} 이상
            </div>
            <div className='interest_fee__col'>{installmentMonth}개월</div>
          </div>
        );
      })}
    </div>
  );
}

const interest_fee = css`
  background: #fff;

  .interest_fee__row {
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${Gray_Light_100};

    &.head {
      background: ${Gray_Light_100};
    }

    .interest_fee__col {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      border-right: 1px solid ${Gray_Light_100};

      &:last-child {
        border: none;
      }
    }
  }
`;
